import script from "./PayrollProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollProjects.vue?vue&type=script&setup=true&lang=js"

import "./PayrollProjects.vue?vue&type=style&index=0&id=51486404&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51486404"]])

export default __exports__